import { render } from "./contentBlock.vue?vue&type=template&id=45870c11&ts=true"
import script from "./contentBlock.vue?vue&type=script&lang=ts"
export * from "./contentBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__